import { createContext, useContext } from 'react';

import { BookingSlot } from '../../../api/search';
import useWeeklyLogic from '../../../hooks/weekly/useWeeklyLogic';
import { CheckoutKid } from '../../state/checkoutKids';

type WeeklySlotsLogic = ReturnType<typeof useWeeklyLogic>;
const WeeklySlotsAPIMethodsContext = createContext<
  WeeklySlotsLogic['api'] | null
>(null);
const WeeklySlotsAPISelectionContext = createContext<
  WeeklySlotsLogic['selection'] | null
>(null);

const WeeklySlotsAPIAvailabilityContext = createContext<
  WeeklySlotsLogic['availability'] | null
>(null);

const isLoggedIn = true;

export default function WeeklySlotsAPIProvider({
  slots,
  kids,
  children,
  initialState = {},
}: {
  kids: CheckoutKid[];
  slots: BookingSlot[];
  children: React.ReactNode;
  initialState?: Record<string, string[]>;
}) {
  const logic = useWeeklyLogic(slots, kids, isLoggedIn, initialState);
  return (
    <WeeklySlotsAPIMethodsContext.Provider value={logic.api}>
      <WeeklySlotsAPISelectionContext.Provider value={logic.selection}>
        <WeeklySlotsAPIAvailabilityContext.Provider value={logic.availability}>
          {children}
        </WeeklySlotsAPIAvailabilityContext.Provider>
      </WeeklySlotsAPISelectionContext.Provider>
    </WeeklySlotsAPIMethodsContext.Provider>
  );
}

export const useWeeklyAPIMethods = () => {
  const ctx = useContext(WeeklySlotsAPIMethodsContext);
  if (!ctx)
    throw new Error('useWeeklyAPIMethods not in WeeklySlotsAPIProvider');
  return ctx;
};

export const useWeeklyAPISelection = () => {
  const ctx = useContext(WeeklySlotsAPISelectionContext);
  if (!ctx)
    throw new Error('useWeeklyAPISelection not in WeeklySlotsAPIProvider');
  return ctx;
};

export const useWeeklyAPIAvailability = () => {
  const ctx = useContext(WeeklySlotsAPIAvailabilityContext);
  if (!ctx)
    throw new Error('useWeeklyAPIAvailability not in WeeklySlotsAPIProvider');
  return ctx;
};
